import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteShopperConfirmationHeaderText: {
    description: 'Text displayed in the header of the delete Shopper confirmation modal',
    defaultMessage: 'Delete Rate Shopper',
    id: 'AjuM7l',
  },
  deleteShopperConfirmationBodyText: {
    description: 'Text displayed in the body of the delete Shopper confirmation modal',
    defaultMessage: 'Are you sure you want to delete this Rate Shopper?',
    id: 'ADrVfa',
  },
  cancelDeletionButtonText: {
    description: 'Text displayed in the cancel button of the delete Rate Shopper confirmation modal',
    defaultMessage: 'Cancel',
    id: 'IwJ2cr',
  },
  confirmDeletionButtonText: {
    description: 'Text displayed in the confirm button of the delete Rate Shopper confirmation modal',
    defaultMessage: 'Delete',
    id: 'Hu0948',
  },
});
